// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/company-working-days",
  Detail: "/pyr/company-working-days/{id}",
  Create: "/pyr/company-working-days",
  Update: "/pyr/company-working-days/{id}",
};
